<template>
  <div>
    <div class="flex items-center justify-center relative">
      <div class="bg-cw-dark-alt/90 font-semibold heightSm:rounded-lg rounded-[18px] heightSm:py-3 heightSm:px-2.5 heightMd:py-3 heightMd:px-4 py-4 px-6">
        <p class="text-white heightMd:text-xs heightSm:text-[10px] text-sm xl:text-[14px] whitespace-nowrap tracking-normal">{{ message }}</p>
      </div>
      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" class="absolute right-0 translate-x-[75%] top-[50%]" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.445788 12.6255L2.83414 0.356921L12.2649 8.55959L0.445788 12.6255Z" fill="rgba(26,26,26,1)" />
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  message?: string
}>()
</script>

<style scoped></style>
